export default function NotFoundPage() {
    return <div>Not Found</div>;
}
